<template>
  <f7-page>
    <f7-navbar>
      <f7-nav-left>
        <f7-link>
          <font-awesome-icon icon="shopping-cart"/>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title>餐點明細</f7-nav-title>
      <f7-nav-right>
        <f7-link
          @click="confirmDelete()">
          <font-awesome-icon icon="trash" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <!-- <order v-if="storeId"></order> -->
    <!-- <cart v-if="currentMenu"></cart> -->
  </f7-page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Cart from '../components/Cart'

export default {
  computed: {
    ...mapGetters([
      'storeId',
      'currentMenu'
    ])
  },
  methods: {
    ...mapActions('itemModule', ['resetBucket']),
    confirmDelete () {
      this.$f7.dialog.confirm('清除已放入購物車的所有餐點?', '清除購物車', () => {
        this.resetBucket({ itemBucket: 'cart' })
        this.$f7router.back()
      })
    }
  },
  components: {
    Cart
  }
}
</script>

<style lang="scss" scoped>
</style>
